<template>
  <div class="home">
    <div class="row">
        <div class="col-3 d-none d-lg-block" id="filter-container">
            <div class="d-flex flex-row filter-header align-items-center justify-content-between">
                <p class="m-0">FILTERS</p>
                <button class="acc-button-2 d-lg-none" @click="toggleFilters()" >Close</button>
            </div>
            <div class="accordion" id="accordionExample">
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        Keyword
                    </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                        <div class="accordion-body text-start">
                            <input class="w-100" type="text" id="search" v-model="searchField" />
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        Location
                    </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            <div class="office text-start d-flex align-items-center" v-bind:key="office.id" v-for="(office) in $parent.offices">
                                <input class="checkbox-round" type="checkbox" :id="'office-'+ office.id" :value="office.id" v-model="officeFilters" />
                                <label :for="'office-'+ office.id">{{office.name}}</label>
                            </div>
                            <div class="filter-buttons d-grid gap-2 d-md-flex justify-content-md-center">
                                <button class="acc-button-2" @click="clearFilter('officeFilters')" >Clear All</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        Department
                    </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            <div class="department text-start d-flex align-items-center" v-bind:key="department.id" v-for="(department) in $parent.departments">
                                <input class="checkbox-round" type="checkbox" :id="'department-'+ department.id" :value="department.id" v-model="departmentFilters" />
                                <label :for="'department-'+ department.id">{{department.name}}</label>
                            </div>
                            <div class="filter-buttons d-grid gap-2 d-md-flex justify-content-md-center">
                                <button class="acc-button-2" @click="clearFilter('departmentFilters')" >Clear All</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-9 col-12">
            <table class="table" id="job-listing-table">
                <thead>
                    <tr>
                        <td class="search-results-text">{{filterJobs($parent.jobs).length}} results</td>
                        <td id="filter-button-mob" class="d-lg-none text-end"><button class="acc-button-2" @click="toggleFilters()" >Filters</button></td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-bind:key="job.id" v-for="(job, index) in getPageData($parent.jobs)">
                        <td :id="'job-' + index" colspan="2">

                        <router-link :to="{ name: 'Job', params: { id: job.id } }" @click.native="scrollToTop" >
                            <div class="job-listing-job d-flex flex-column justify-content-center">
                                <div class="job-listing-title">{{job.title}}</div>
                                <div class="job-listing-meta" v-if="job.departments.length > 0 && job.location != null">
                                    
                                    {{job.departments[0].name}} |

                                    <span class="job-listing-locations" v-if="job.offices.length <= 3">
                                        <span class="job-listing-location" v-bind:key="office.id" v-for="(office, index) in job.offices">
                                            {{office.name}}
                                            <span v-if="index < job.offices.length - 1">/</span>
                                        </span>
                                    </span>
                                    <span v-else>
                                        Multiple Locations
                                    </span>
                                    
                                </div>
                            </div>
                        </router-link>    
                        </td>
                    </tr>
                </tbody>
            </table>
             <!-- <pagination :records="filterJobs($parent.jobs).length" v-model="page" :per-page="perPage" @paginate="pageChange" :options="options"></pagination> -->
             <button v-if="filterJobs($parent.jobs).length > perPage" class="acc-button-2" @click="loadMore">Load More</button>
        </div>
    </div>
    
  </div>
</template>

<script>
// @ is an alias to /src

// import Pagination from 'vue-pagination-2';
import MyPagination from '@/components/MyPagination'


export default {
  name: 'Home',
  data() {
        return {
            searchField: "",
            page: 1,
            perPage: 20,
            departmentFilters: [],
            officeFilters: [],
            options: {
                template: MyPagination    
            },
            locations: {
                bulgaria: [4041602002,4031800002],
                canada: [4043042002,4031798002],
                china: [4039003002],
                colombia: [4031794002],
                uk: [4031792002],
                germany: [4031788002,4034731002,4031797002,4041693002],
                india: [4031779002],
                slovakia: [4031790002],
                turkey: [4031789002],
                ukraine: [4039556002,4031782002,4039554002,4039555002,4031791002,4031793002,4039553002,4039552002,4031799002,4031801002],
                us: [4042994002,4041347002,4041346002,4031784002,4031786002,4041313002,4031781002,4031780002],
                remote: [4042994002,4046048002,4039552002,4041693002,4041664002,4041602002,4043042002,4046030002,4041601002]
            }
        }  
  },
  components: {
    // Pagination
  },
  mounted() {
      if ( document.getElementById('section-3-7') ) document.getElementById('section-3-7').style.display = 'flex';
      document.body.classList.remove('acc-job');
      if ( localStorage.lastVisited ) {
          if ( Math.floor( ( Date.now() - localStorage.lastVisited ) / 1000 ) > 600 ) {
              localStorage.clear();
          }
      }
      localStorage.lastVisited = Date.now();
      if ( localStorage.perPage ) this.perPage = parseInt(localStorage.perPage);
      if ( localStorage.departmentFilters ) this.departmentFilters = JSON.parse(localStorage.departmentFilters);
      if ( localStorage.officeFilters ) this.officeFilters = JSON.parse(localStorage.officeFilters);
      if ( localStorage.searchField ) this.searchField = localStorage.searchField;
    if (this.$route.query.location != null) {
        let location = this.$route.query.location;
        this.officeFilters = this.locations[location];
        this.departmentFilters = [];
        this.searchField = "";
        this.$router.replace({
            ...this.$router.currentRoute,
            query: {
                location: undefined
            }
        })
    }

  },
  watch: {
      departmentFilters: function(newVal, oldVal) {
        if (newVal !== oldVal) {
            this.page = 1;
            this.perPage = 20;
            localStorage.departmentFilters = JSON.stringify(newVal);
        }
      },
      officeFilters: function(newVal, oldVal) {
        if (newVal !== oldVal) {
            this.page = 1;
            this.perPage = 20;
            localStorage.officeFilters = JSON.stringify(newVal);
            console.log(newVal);
        }
      },
      searchField: function(newVal, oldVal) {
        if (newVal !== oldVal) {
            this.page = 1;
            this.perPage = 20;
            localStorage.searchField = newVal;
        }
      },
      perPage: function(newVal, oldVal) {
          if (newVal !== oldVal) {
              localStorage.perPage = newVal;
          }
      }
  },
  methods: {
        scrollToTop() {
            window.scrollTo(0,0);
        },
        filterJobs: function( jobs ) {
            if ( this.departmentFilters.length == 0 && this.officeFilters.length == 0 && this.searchField.length == 0 ) return jobs;
            // let deptFiltered = jobs.filter(this.isInDepartments);
            // let officeFiltered = jobs.filter(this.isInOffices);
            // let merged = deptFiltered.concat(officeFiltered);
            // merged = [...new Set([...deptFiltered,...officeFiltered])];
            return jobs.filter(this.isInDepartments).filter(this.isInOffices).filter(this.isInSearch);
        },
        getPageData: function( jobs ) {
            let startIndex = (this.page - 1) * this.perPage;
            let endIndex = (this.page * this.perPage) - 1;
            return this.filterJobs(jobs).slice(startIndex, endIndex);
        },
        isSelected: function( job ) {
            return this.departmentFilters.includes(job.departments[0].id) || this.officeFilters.includes(job.offices[0].id);
        },
        isInSearch: function( job ) {
            if ( this.searchField.length == 0 ) return true;
            return job.title.toLowerCase().indexOf( this.searchField.toLowerCase() ) > -1;
        },
        isInDepartments: function( job ) {
            if ( this.departmentFilters.length == 0 || job.departments.length == 0 ) return true;
            return this.departmentFilters.includes(job.departments[0].id);
        },
        isInOffices: function( job ) {
            if ( this.officeFilters.length == 0  || job.offices.length == 0 ) return true;
            for ( let i = 0; i < job.offices.length; i++ ) {
                if ( this.officeFilters.includes(job.offices[i].id) ) return true;
            }
            return false;
        },
        pageChange: function() {
            //Do Nothing
        },
        clearFilter: function( filter ) {
            this[filter] = [];
        },
        toggleFilters: function() {
            document.getElementById('filter-container').classList.toggle("d-none");
        },
        loadMore: function() {
            if ( this.filterJobs(this.$parent.jobs).length > this.perPage + 20 ) {
                this.perPage += 20;
            } else {
                this.perPage = this.filterJobs(this.$parent.jobs).length;
            }
        }
  }
}
</script>